<template>
  <v-card class="mt-3 rounded-card card-shadow">
    <v-card-title class="heading font-weight-bold">
      Entregas
    </v-card-title>
    <v-card-text class="text--primary">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && sortedProdutos.length">
        <px-gestao-entrega-produtos-compras-item v-for="(item, index) in sortedProdutos"
                                                 :key="item.id"
                                                 :outlined="outlined"
                                                 :controla-faturamento="hasControleFaturamento"
                                                 :compra-produto="item"
                                                 :loading="loadingMap[item.id]"
                                                 @change="onChangeItem(item, index)"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { sortBy } from 'lodash';
import { CasaDecimalUtils } from 'px-components';
import GestaoEntregaProdutosComprasItem
  from '@/modules/gestao-entregas/GestaoEntregaProdutosComprasItem.vue';
import GestaoEntregaService from '@/modules/gestao-entregas/gestao-entrega-service';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingMap: {},
      produtos: [],
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: '',
          value: 'options',
          align: 'end',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('entidade', ['hasControleFaturamento']),
    sortedProdutos() {
      return sortBy(this.produtos, 'id');
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
  },
  methods: {
    getItensCompra() {
      this.loading = true;
      GestaoEntregaService.getItensCompra(this.compra.id)
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateItemReference(item) {
      Vue.set(this.loadingMap, item.id, true);
      GestaoEntregaService.getItemCompraSaldos(item.id)
        .then(({ data }) => {
          this.produtos = [...this.produtos.filter(p => p.id !== item.id), data];
        })
        .finally(() => {
          this.loadingMap[item.id] = false;
        });
    },
    onChangeItem(item) {
      this.updateItemReference(item);
    },
  },
  created() {
    this.getItensCompra();
  },
  components: {
    pxGestaoEntregaProdutosComprasItem: GestaoEntregaProdutosComprasItem,
  },
};
</script>
